<template>
  <div class="exhibition" style="font-family: 微软雅黑;">
    <Head></Head>
    <div class="container" v-if="isPhone==false">
      <div class="block1">
        <img alt="xxx" src="../../assets/exhibition-bj/imgs/101.png" style="width: 100%;" />
      </div>
      <div class="block2" style="padding-top: 40px;padding-bottom: 40px;">
        <img alt="xxx" src="../../assets/exhibition-bj/imgs/102.png" style="width: 100%;" />
      </div>
      <div class="block3">
        <div v-if="navIndex==1">
          <div class="navigation">
            <div class="nav1 navBlue" @click="changeNav1()">
              <span class="navSelect">车展概况</span>
            </div>
            <div class="nav2" @click="changeNav2()">最新资讯</div>
            <div class="nav3" @click="changeNav3()">车展亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content1" style="margin-top: 40px;">
            <div class="contain" style="display: flex;align-items: center;">
              <div class="left">
                <img alt="xxx" src="../../assets/exhibition-bj/imgs/103.png" style="width: 100%;" />
              </div>
              <div class="right">
                <div class="text" style="padding-left: 60px;padding-top: 0px">
                  9月26日，2020（第十六届）北京国际汽车展览会正式开启。上汽大众携多款新车重磅亮相中国国际展览中心（天竺）新馆W4展馆，让我们相约北京。
                  <div style="padding-top: 40px;display: flex;justify-content: space-between;">
                    <div>
                      <div>
                        <span
                          style="background: #0078C8;color: #ffffff;width: 100px;line-height: 30px;display: inline-block;text-align: center;"
                        >日程安排</span>
                      </div>
                      <div>
                        <span style="font-weight: bolder;">媒体日</span>
                        <span style="float: right;">9月26日-9月27日</span>
                        <div style="height: 1px;background: #CECECE;"></div>
                      </div>
                      <div>
                        <span style="font-weight: bolder;">专业观众日</span>
                        <span style="float: right;padding-left: 20px;">9月28日-9月29日</span>
                        <div style="height: 1px;background: #CECECE;"></div>
                      </div>
                      <div>
                        <span style="font-weight: bolder;">公众日</span>
                        <span style="float: right;">9月30日-10月5日</span>
                        <div style="height: 1px;background: #CECECE;"></div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <span
                          style="background: #0078C8;color: #ffffff;width: 70px;line-height: 30px;display: inline-block;text-align: center;"
                        >地址</span>
                      </div>

                      <div>
                        中国国际展览中心（天竺）新馆
                        <div style="height: 1px;background: #CECECE;"></div>
                      </div>

                      <div>
                        北京市顺义区裕翔路88号
                        <div style="height: 1px;background: #CECECE;"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==2">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2 navBlue" @click="changeNav2()">
              <span class="navSelect">最新资讯</span>
            </div>
            <div class="nav3" @click="changeNav3()">车展亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content2" style="margin-top: 40px;">
            <div class="contain">
              <div
                class="item"
                style="display: flex;align-items: center;"
                v-for="(item,index) in zixunlist"
                :key="index"
                @click="toUrl(item.tourl)"
              >
                <div class="left">
                  <img :src="item.url" style="width: 100%;" />
                </div>
                <div class="right">
                  <div class="title-ex" style="margin-top:0px">{{item.text}}</div>
                  <div class="text">{{item.dec}}</div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==3">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2" @click="changeNav2()">最新资讯</div>
            <div class="nav3 navBlue" @click="changeNav3()">
              <span class="navSelect">车展亮点</span>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="content3" style="margin-top: 40px;">
            <!-- <div class="select-contain">
              <select
                class="select-option"
                id="option"
                v-model="selectItem"
                @change="selectChange()"
              >
                <option
                  v-bind:key="item.id"
                  v-for="item in selectTtems"
                  :value="item.id"
                >{{item.value}}</option>
              </select>
              <div style="clear: both;"></div>
            </div>-->
            <div class="contain" v-if="sec3Type==1">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" style="cursor: pointer;" @click="showPop(item.num1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                  <div class="text">{{item.text1}}</div>
                  <div style="padding: 10px;color: #343434;font-size: 14px;">{{item.dec1}}</div>
                </div>
                <div
                  class="middle"
                  style="cursor: pointer;"
                  @click="showPop(item.num2)"
                  v-show="item.url2"
                >
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                  <div class="text">{{item.text2}}</div>
                  <div style="padding: 10px;color: #343434;font-size: 14px;">{{item.dec2}}</div>
                </div>
                <!-- <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                  <div class="text">{{item.text3}}</div>
                </div>-->
                <div style="clear: both;"></div>
              </div>
            </div>
            <div class="contain" v-if="sec3Type==2">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" @click="showPop(item.url1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                </div>
                <div class="middle" @click="showPop(item.url2)">
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                </div>
                <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          <div class="cover" v-if="showCover"></div>
          <div class="popup" v-if="showCover" style="width:960px;height:620px">
            <div>
              <div class="close" @click="closePop()">
                <img alt="xxx" src="../../assets/exhibition/imgs/106.png" style="width: 100%;" />
              </div>
              <div class="img">
                <el-carousel
                  indicator-position="none"
                  :autoplay="false"
                  arrow="always"
                  style="width: 100%;"
                  height="600px"
                >
                  <el-carousel-item v-for="(item,index) in picsArrImg[picsArrIndex]" :key="index">
                    <div v-if="item.type==2">
                      <video
                        preload="auto"
                        controls
                        controlslist="nodownload"
                        :disablePictureInPicture="true"
                        type="video/mp4"
                        :src="item.url"
                        style="width: 100%;"
                      ></video>
                    </div>
                    <div v-if="item.type==1">
                      <img :src="item.url" style="width: 100%;" />
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <ExhibitionMobile v-if="isPhone"></ExhibitionMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import config from "./config";
import { getBrowserType, getBrowserHight } from "../../components/js/screen.js";
import ExhibitionMobile from "./ExhibitionMobile";
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
export default {
  name: "Exhibition",
  components: {
    ExhibitionMobile,
    Head,
    Foot
  },
  data() {
    return {
      isPhone: false,
      // 咨询列表
      zixunlist: [
        {
          text: "上汽大众携全新阵容闪耀2020北京车展",
          url: require("../../assets/exhibition-bj/imgs/201.png"),
          tourl:
            "https://www.csvw.com/csvw-website/news/company-news.html?newsid=2851",
          dec:
            "9月26日，2020北京车展隆重开幕，上汽大众携全新展车阵容，亮相中国国际展览中心（天竺）新馆W4展馆。"
        },
        {
          text:
            "途观X开启预售 新辉昂首发亮相 上汽大众大众品牌携全新展车阵容闪耀2020北京车展",
          url: require("../../assets/exhibition-bj/imgs/202.png"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2847",
          dec:
            "9月26日，2020（第十六届）北京国际汽车展览会隆重开幕。上汽大众大众品牌携全新展车阵容亮相中国国际展览中心（天竺）新馆W4展馆。全新轿跑SUV途观X首次与公众见面，同时正式开启预售，旗舰品质座驾新辉昂重磅首发。此外，途昂X极夜限定版、途岳2021款及凌渡2021款等多款近期上市的新车悉数登台。上汽大众大众品牌成为本届车展中备受关注的大热门。"
        },
        {
          text: "2021款柯珞克预售开启 北京车展上汽大众斯柯达驭光而来",
          url: require("../../assets/exhibition-bj/imgs/203.png"),
          tourl:
            "https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2850",
          dec:
            "近日，2020北京车展开幕，上汽大众斯柯达品牌SUV家族5款车型以及昕锐、昕动、明锐、速派携手亮相中国国际展览中心（天竺）新馆W4馆。位于斯柯达展台中央的2021款柯珞克首发亮相并启动预售，其为车展特别打造的金色涂装令人眼前一亮。"
        },
        {
          text: "24.6万元-30.6万元 高端型格轿跑SUV途观X开启预售",
          url: require("../../assets/exhibition-bj/imgs/204.png"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2849",
          dec:
            "9月26日，2020（第十六届）北京国际汽车展览会拉开帷幕。上汽大众全新轿跑SUV途观X亮相中国国际展览中心（天竺）新馆W4展馆，带来高端型格轿跑SUV的独特魅力。现场，途观X公布预售价格24.6万元-30.6万元，正式开启预售。"
        },
        {
          text: "豪华动感新格调 大众品质旗舰新辉昂首发亮相 ",
          url: require("../../assets/exhibition-bj/imgs/205.png"),
          tourl:
            "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2848",
          dec:
            "9月26日，2020（第十六届）北京国际汽车展览会隆重开幕，上汽大众携大众品牌旗舰品质座驾新辉昂重磅首发。新辉昂是大众全球首款运用了LED发光LOGO的座驾，其采用大众品牌最新设计语言，并用更具情感化、更加动感的造型元素，营造出豪华前沿的新格调。据悉，新车预计将于今年10月上市。"
        }
      ],

      navIndex: 1, // 导航页签
      sec3Type: 1, // 第三个图片的类型
      showCover: false,
      popUrl: require("../../assets/exhibition/imgs/301.jpg"),
      selectItem: "1",
      selectTtems: [
        { id: "1", value: "大众品牌车型" },
        { id: "2", value: "斯柯达品牌车型" },
        { id: "3", value: "车展花絮" }
      ],
      picsArr: [
        {
          text1: "Viloran 威然",
          url1: require("../../assets/exhibition/imgs/301.jpg"),
          text2: "Teramont X 途昂X",
          url2: require("../../assets/exhibition/imgs/302.jpg"),
          text3: "Teramont 途昂",
          url3: require("../../assets/exhibition/imgs/303.jpg")
        }
      ],
      picsArrIndex: 0,
      picsArrImg: config.picsArrImg
    };
  },
  mounted: function() {
    // 判断是否手机
    this.getIsPhone();
    this.setSectionHeight();
    // 浏览器改变大小监听事件
    window.onresize = this.setSectionHeight;
    this.setTitle();
  },
  methods: {
    setSectionHeight() {
      const h = getBrowserHight();
      const height = `${h}px`;
      //document.getElementById("left").style.height = height;
    },
    changeNav1() {
      this.navIndex = 1;
    },
    changeNav2() {
      this.navIndex = 2;
    },
    changeNav3() {
      this.navIndex = 3;
      this.change1();
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "北京国际汽车展览会";
    },
    selectChange() {
      if (this.selectItem == "1") {
        this.change1();
      } else if (this.selectItem == "2") {
        this.change2();
      } else if (this.selectItem == "3") {
        this.change3();
      }
    },
    change1() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          num1: 0,
          num2: 1,
          text1: "途观X Tiguan X",
          url1: require("../../assets/exhibition-bj/imgs/301.png"),
          dec1:
            "高端型格轿跑SUV途观X将SUV车型和Coupe车型的设计风格融为一体，造就灵动线条与宽适空间，彰显天生运动基因。",
          text2: "新辉昂 New PHIDEON",
          url2: require("../../assets/exhibition-bj/imgs/302.jpg"),
          dec2:
            "大众品牌旗舰品质座驾新辉昂采用大众品牌最新设计语言，首次运用了大众品牌发光LOGO，用更具情感化、更加动感的造型元素，营造出豪华前沿的新格调。"
        },
        {
          num1: 2,
          num2: 3,

          text1: "途昂X Teramont X",
          url1: require("../../assets/exhibition-bj/imgs/311.png"),
          dec1:
            "途昂X是上汽大众旗舰豪华运动型SUV，其运动豪华造型设计备受好评。途昂X 2020款拥有全新星辰蓝色车身外观，并搭载平视显示系统，在安全配置方面也有提升，彰显强者更强的市场竞争力。",
          text2: "威然 Viloran",
          url2: require("../../assets/exhibition-bj/imgs/312.png"),
          dec2:
            "作为上汽大众首款大型豪华商务MPV，威然集空间、舒享、尊贵、远见于一身，重新定义了豪华商务的典范。"
        },
        {
          num1: 4,
          num2: 5,
          text1: "途观L插电式混合动力版 Tiguan L PHEV",
          url1: require("../../assets/exhibition-bj/imgs/321.png"),
          dec1:
            "途观L插电式混合动力版汇集大众的新能源技术，运用高安全标准打造“放心使用的PHEV”。",
          text2: "帕萨特插电式混合动力版 Passat PHEV",
          url2: require("../../assets/exhibition-bj/imgs/322.png"),
          dec2:
            "帕萨特插电式混合动力版以先进的双擎动力科技、强劲又不失平顺的驾控体验、令人放心的安全防护，成为PHEV细分市场的破局者。"
        },
        {
          num1: 6,
          num2: 7,
          text1: "柯珞克 KAROQ",
          url1: require("../../assets/exhibition-bj/imgs/331.png"),
          dec1:
            "亮相本次车展的2021款柯珞克，整体造型硬朗、动感，极富情感张力，兼具宽敞的内部空间和高效节能的动力组合，拥有如水晶般精雕细琢的立体式尾灯，便捷省力的电动尾门，搭载斑马智行系统的9吋中控大屏，四大驾驶模式。"
        }
      ];
    },
    change2() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          text1: "KODIAQ 柯迪亚克",
          url1: require("../../assets/exhibition/imgs/401.jpg"),
          text2: "KAROQ 柯珞克智行款",
          url2: require("../../assets/exhibition/imgs/402.jpg"),
          text3: "KAMIQ 柯米克",
          url3: require("../../assets/exhibition/imgs/403.jpg")
        },
        {
          text1: "KODIAQ GT 柯迪亚克GT",
          url1: require("../../assets/exhibition/imgs/404.jpg"),
          text2: "KAMIQ GT 柯米克GT",
          url2: require("../../assets/exhibition/imgs/405.jpg"),
          text3: "SUPERB 速派",
          url3: require("../../assets/exhibition/imgs/406.jpg")
        },
        {
          text1: "OCTAVIA 明锐智行款",
          url1: require("../../assets/exhibition/imgs/407.jpg"),
          text2: "RAPID 昕锐",
          url2: require("../../assets/exhibition/imgs/408.jpg")
        }
      ];
    },
    change3() {
      this.sec3Type = 2;
      this.picsArr = [
        {
          url1: require("../../assets/exhibition/imgs/501.jpg"),
          url2: require("../../assets/exhibition/imgs/502.jpg"),
          url3: require("../../assets/exhibition/imgs/503.jpg")
        },
        {
          url1: require("../../assets/exhibition/imgs/504.jpg"),
          url2: require("../../assets/exhibition/imgs/505.jpg"),
          url3: require("../../assets/exhibition/imgs/506.jpg")
        },
        {
          url1: require("../../assets/exhibition/imgs/507.jpg"),
          url2: require("../../assets/exhibition/imgs/508.jpg"),
          url3: require("../../assets/exhibition/imgs/509.jpg")
        }
      ];
    },
    showPop(num) {
      this.showCover = true;
      this.picsArrIndex = num;
    },
    toUrl(url) {
      window.location = url;
    },
    closePop() {
      this.showCover = false;
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  min-width: 1024px;
}
@media screen and (min-width: 1px) {
  .block2 {
    padding: 0 300px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }
  .navigation .navSelect {
    border-bottom: solid 2px rgba(0, 119, 199, 1);
    padding-bottom: 10px;
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 16px;
    line-height: 40px;
    color: rgba(51, 51, 51, 1);
    padding-left: 80px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 20px;
    line-height: 44px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 50px;
  }
  .content2 .right .text {
    font-size: 16px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 180px;
    height: 30px;
    font-size: 16px;
    line-height: 28px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 800px;
    height: 571.4px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 20px;
    cursor: pointer;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .block2 {
    padding: 0 100px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 12px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    padding-left: 60px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 20px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 17px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 200px;
    margin-right: 200px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 120px;
    height: 20px;
    font-size: 12px;
    line-height: 18px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 25px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 13px;
    line-height: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 17px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 600px;
    height: 428.6px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .block2 {
    padding: 0 134px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 14px;
    line-height: 33px;
    color: rgba(51, 51, 51, 1);
    padding-left: 70px;
    padding-top: 100px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 70px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 250px;
    margin-right: 250px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 180px;
    height: 30px;
    font-size: 13px;
    line-height: 23px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(50% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 700px;
    height: 500px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
</style>